import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  inject,
} from '@angular/core';

@Component({
  selector: 'app-datos-geograficos-cemento-carga-masiva-modal',
  templateUrl: './datos-geograficos-cemento-carga-masiva-modal.component.html',
  styleUrls: ['./datos-geograficos-cemento-carga-masiva-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatosGeograficosCementoCargaMasivaModalComponent {
  @ViewChild('excelFileInput') excelFileInput?: ElementRef<HTMLInputElement>;

  private readonly cdr = inject(ChangeDetectorRef);

  @Output() closeRequested = new EventEmitter<void>();
  @Output() uploadRequested = new EventEmitter<File>();

  archivoExcel: File | null = null;
  nombreArchivoExcel = '';
  errorArchivoExcel = false;

  onClose(): void {
    this.closeRequested.emit();
  }

  triggerExcelFileInput(): void {
    queueMicrotask(() => {
      this.excelFileInput?.nativeElement.click();
    });
  }

  onExcelFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const selectedFile = input.files?.[0] ?? null;
    if (!selectedFile) {
      return;
    }

    const nameOk = /\.xlsx$/i.test(selectedFile.name);
    const typeOk =
      selectedFile.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    if (!nameOk && !typeOk) {
      this.errorArchivoExcel = true;
      this.archivoExcel = null;
      this.nombreArchivoExcel = '';
      input.value = '';
      this.cdr.markForCheck();
      return;
    }

    this.errorArchivoExcel = false;
    this.archivoExcel = selectedFile;
    this.nombreArchivoExcel = selectedFile.name;
    this.cdr.markForCheck();
  }

  onUpload(): void {
    const file = this.archivoExcel;
    if (!file || file.size === 0) {
      return;
    }
    this.uploadRequested.emit(file);
  }

  resetSelection(): void {
    this.archivoExcel = null;
    this.nombreArchivoExcel = '';
    this.errorArchivoExcel = false;
    const input = this.excelFileInput?.nativeElement;
    if (input) {
      input.value = '';
    }
  }
}
